import { BarChart2 } from 'lucide-react';
import type { StatsBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const statsConfig: BlockTypeConfig<StatsBlock> = {
  type: 'stats',
  label: 'Stats',
  description: 'Display key statistics and metrics',
  icon: BarChart2,
  category: 'data',
  createDefault: () => ({
    items: [
      { id: crypto.randomUUID(), value: '350K+', label: 'Riders worldwide' },
      { id: crypto.randomUUID(), value: '$37M', label: 'Raised so far' },
      { id: crypto.randomUUID(), value: '120', label: 'Cities' },
    ],
    columns: 3,
    style: 'cards',
    alignment: 'center',
    accentColor: 'primary',
    showDividers: false,
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.columns',
      label: 'Columns',
      options: [
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
      ],
    },
    {
      kind: 'select',
      path: 'data.style',
      label: 'Style',
      options: [
        { value: 'cards', label: 'Cards' },
        { value: 'inline', label: 'Inline' },
        { value: 'minimal', label: 'Minimal' },
      ],
    },
    {
      kind: 'select',
      path: 'data.alignment',
      label: 'Align',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  variants: [
    {
      id: 'default',
      label: 'Cards',
      thumbnail: '/admin/page-editor/variants/stats-default.svg',
      apply: (d) => ({ ...d, variant: 'default', style: 'cards' }),
    },
    {
      id: 'oversized-numbers',
      label: 'Oversized numbers',
      thumbnail: '/admin/page-editor/variants/stats-oversized-numbers.svg',
      apply: (d) => ({ ...d, variant: 'oversized-numbers', style: 'minimal' }),
    },
  ],
  sheet: [
    {
      kind: 'group',
      label: 'Heading',
      fields: [
        { kind: 'text', path: 'data.title', label: 'Title' },
        { kind: 'text', path: 'data.subtitle', label: 'Subtitle' },
      ],
    },
    {
      kind: 'group',
      label: 'Style',
      fields: [
        {
          kind: 'select',
          path: 'data.accentColor',
          label: 'Number colour',
          options: [
            { value: 'primary', label: 'Primary' },
            { value: 'foreground', label: 'Default text' },
            { value: 'muted', label: 'Muted' },
          ],
        },
        { kind: 'toggle', path: 'data.showDividers', label: 'Show dividers between items' },
      ],
    },
  ],
  repeatingItems: {
    arrayPath: 'data.items',
    itemFactory: () => ({
      id: crypto.randomUUID(),
      value: '0',
      label: 'New stat',
    }),
    addLabel: 'Add stat',
  },
};
